import React from 'react';
import PropTypes from 'prop-types';
import Button from 'react-bootstrap/Button';

const CropperController = props => {
  const {
    cropping, photoToEdit, onCrop, onRemove, onReset, onSave, imageURL, imageFileName,
  } = props;

  const handleDeleteClick = () => {
    onRemove(photoToEdit);
  };

  return (
    <div>
      {cropping && (
        <div className="btn-group mr-2">
          <button
            name="btnCancelCropperImage"
            type="button"
            className="btn btn-primary cropperControllerButton"
            onClick={onReset}
            title="Cancel"
          >
            <i className="far fa-times mr-2" />
            Cancel
          </button>
          <button
            name="btnOkCropperImage"
            type="button"
            className="btn btn-primary cropperControllerButton"
            onClick={onCrop}
            title="OK"
          >
            <i className="far fa-check mr-2" />
            OK
          </button>
        </div>
      )}
      <Button
        name="btnDownloadImage"
        variant="primary"
        href={imageURL}
        download={imageFileName}
      >
        <i className="fas fa-download mr-2" />
        Download
      </Button>
      <div className="float-right">
        <button
          type="button"
          className="btn btn-danger ml-2 cropperControllerButton "
          onClick={handleDeleteClick}
          data-dismiss="modal"
          title="Delete"
        >
          <i className="fas fa-trash-alt mr-2" />
          Delete
        </button>
        <button
          type="button"
          className="btn btn-success ml-2 cropperControllerButton "
          onClick={onSave}
          data-dismiss="modal"
          title="Save"
        >
          <i className="fas fa-save mr-2" />
          Save
        </button>
      </div>
    </div>
  );
};

CropperController.propTypes = {
  cropping: PropTypes.bool,
  imageURL: PropTypes.string,
  imageFileName: PropTypes.string,
  photoToEdit: PropTypes.oneOfType([PropTypes.string, PropTypes.shape()]),
  onCrop: PropTypes.func,
  onRemove: PropTypes.func,
  onReset: PropTypes.func,
  onSave: PropTypes.func,
};

export default CropperController;
